import logger from '#utils/logger';

export interface BuildInfo {
  commit: string;
  branch: string;
  isDev: boolean;
  buildTime: string;
}

const fallbackBuildInfo: BuildInfo = {
  commit: 'dev',
  branch: '',
  isDev: true,
  buildTime: new Date().toISOString(),
};

// Import build info from generated source file.
// This is generated at build time to ensure it matches the source code.
let buildInfo: BuildInfo = fallbackBuildInfo;

try {
  const { buildInfo: generatedBuildInfo } = await import(
    '../generated/build-info.js'
  );
  buildInfo = generatedBuildInfo;
} catch (error) {
  if (!import.meta.env.DEV) {
    logger.warn({ err: error }, 'Failed to load build info');
  }
}

export { buildInfo };
